import { z } from 'zod';
import { idSchema } from './common.js';
/**
 * Gespeicherte Ansichten (SPEC 9.3).
 *
 * `query` ist der Query-String der Filterleiste — genau der, der auch in der
 * URL steht. Kein zweites Format: eine neue Filterdimension braucht dann hier
 * keine Migration und kein Mapping, das man vergessen kann.
 */
export const createViewSchema = z.object({
    name: z.string().min(1, 'Name ist Pflicht').max(60),
    query: z.string().max(1000),
    /** Leer: die Ansicht gilt boarduebergreifend. */
    boardId: idSchema.nullable().optional(),
    afterViewId: idSchema.nullable().optional(),
});
export const patchViewSchema = z
    .object({
    name: z.string().min(1).max(60).optional(),
    query: z.string().max(1000).optional(),
    afterViewId: idSchema.nullable().optional(),
})
    .refine((value) => Object.keys(value).length > 0, { message: 'Keine Aenderung angegeben' });
//# sourceMappingURL=view.js.map